/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CategorySettingsEntity } from '../models/CategorySettingsEntity';
import type { CategorySettingsResponse } from '../models/CategorySettingsResponse';
import type { CreateCategorySettingsDto } from '../models/CreateCategorySettingsDto';
import type { GetManyCategorySettingsEntityResponseDto } from '../models/GetManyCategorySettingsEntityResponseDto';
import type { UpdateCategorySettingsDto } from '../models/UpdateCategorySettingsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CategoriesSettingsApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Create a single category settings
   * @returns CategorySettingsResponse
   * @throws ApiError
   */
  public createOneBase({
    requestBody,
  }: {
    requestBody: CreateCategorySettingsDto,
  }): CancelablePromise<CategorySettingsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/categories-settings',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        409: `Category settings already exist`,
      },
    });
  }
  /**
   * Retrieve multiple category settings
   * @returns any Get many base response
   * @throws ApiError
   */
  public getCategorySettings({
    fields,
    s,
    filter,
    or,
    sort,
    join,
    limit,
    offset,
    page,
    cache,
  }: {
    /**
     * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
     */
    fields?: Array<string>,
    /**
     * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
     */
    s?: string,
    /**
     * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
     */
    filter?: Array<string>,
    /**
     * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
     */
    or?: Array<string>,
    /**
     * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
     */
    sort?: Array<string>,
    /**
     * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
     */
    join?: Array<string>,
    /**
     * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
     */
    limit?: number,
    /**
     * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
     */
    offset?: number,
    /**
     * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
     */
    page?: number,
    /**
     * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
     */
    cache?: number,
  }): CancelablePromise<(GetManyCategorySettingsEntityResponseDto | Array<CategorySettingsEntity>)> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/categories-settings',
      query: {
        'fields': fields,
        's': s,
        'filter': filter,
        'or': or,
        'sort': sort,
        'join': join,
        'limit': limit,
        'offset': offset,
        'page': page,
        'cache': cache,
      },
    });
  }
  /**
   * Update a single category settings
   * @returns CategorySettingsEntity Response
   * @throws ApiError
   */
  public updateOneCategorySetting({
    id,
    requestBody,
  }: {
    id: number,
    requestBody: UpdateCategorySettingsDto,
  }): CancelablePromise<CategorySettingsEntity> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/categories-settings/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Retrieve a single category settings
   * @returns CategorySettingsEntity Get one base response
   * @throws ApiError
   */
  public getOneCategorySetting({
    id,
    fields,
    join,
    cache,
  }: {
    id: number,
    /**
     * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
     */
    fields?: Array<string>,
    /**
     * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
     */
    join?: Array<string>,
    /**
     * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
     */
    cache?: number,
  }): CancelablePromise<CategorySettingsEntity> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/categories-settings/{id}',
      path: {
        'id': id,
      },
      query: {
        'fields': fields,
        'join': join,
        'cache': cache,
      },
    });
  }
}
